(function($) {
    
    const buttons = document.querySelectorAll('.template-trabalhe-conosco .vagas-disponiveis .filtro button')
    
    if(buttons) {
        const vagas = document.querySelectorAll('.template-trabalhe-conosco .vagas-disponiveis .vagas li')
        
        if(vagas) {
            buttons.forEach(button => {
                button.addEventListener('click', event => {
                    const currentTarget = event.currentTarget
                    const target = currentTarget.dataset.target
                    
                    if(currentTarget.classList.contains('active')) return
                    
                    buttons.forEach(button => button.classList.remove('active'))
                    currentTarget.classList.add('active')
                    
                    vagas.forEach(vaga => {
                        vaga.dataset.content === target || !target
                            ? vaga.classList.remove('hidden')
                            : vaga.classList.add('hidden')
                    })
                })
            })
        }
    }
    
})(jQuery);